import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import FilesetPage from './FilesetPage';
import { openDialog, closeDialog } from '../../actions/dialog';
import {
  listFilesets,
  changePage,
  deleteFileset,
  retrieveRecordLevelTypes,
  fetchFieldsById,
} from '../../actions/superadmin';
import FilesetFormContainer from './FilesetFormContainer';
import UploadLayoutFormContainer from './UploadLayoutFormContainer';
import { storeWithExpiration } from '../../utils/common';

const BLANK_VALUES = new Map({
  id: 0,
  dataFilenamePattern: '',
  layoutFilename: '',
  recordLevelTypeId: 0,
});

export class FilesetPageContainer extends React.Component {
  static propTypes = {
    superadmin: PropTypes.object.isRequired,
    retrieveRecordLevelTypesAction: PropTypes.func.isRequired,
    recordLevelTypes: PropTypes.object.isRequired,
    listFilesetsAction: PropTypes.func.isRequired,
    pageChangeAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    deleteFilesetAction: PropTypes.func.isRequired,
    fetchFieldsByIdAction: PropTypes.func.isRequired,
    datasetId: PropTypes.number.isRequired,
    datasetName: PropTypes.string.isRequired,
  };

  componentWillMount = () => {
    const {
      pageChangeAction,
      listFilesetsAction,
      retrieveRecordLevelTypesAction,
      datasetId,
    } = this.props;
    const token = storeWithExpiration.get('token');
    pageChangeAction(0, BLANK_VALUES);
    listFilesetsAction(token, datasetId);
    retrieveRecordLevelTypesAction();
  };

  handlePageChange = (nextPage, values) => {
    const { pageChangeAction } = this.props;
    pageChangeAction(nextPage, values);
  };

  performDeleteFileset = (datasetId, fileset) => {
    const { deleteFilesetAction } = this.props;
    const token = storeWithExpiration.get('token');
    deleteFilesetAction(token, datasetId, fileset);
  };

  render() {
    const {
      superadmin,
      listFilesetsAction,
      dialog,
      openDialogAction,
      closeDialogAction,
      pageChangeAction,
      fetchFieldsByIdAction,
      recordLevelTypes,
      datasetId,
      datasetName,
    } = this.props;
    return (
      <div>
        {superadmin.get('currPage') === 0 ? (
          <FilesetPage
            datasetId={datasetId}
            datasetName={datasetName}
            filesets={superadmin.get('filesets')}
            pageProgression={this.handlePageChange}
            listFilesetsFunction={listFilesetsAction}
            dialog={dialog}
            recordLevelTypes={recordLevelTypes}
            openDialogFunction={openDialogAction}
            closeDialogFunction={closeDialogAction}
            deleteFilesetFunction={this.performDeleteFileset}
            fetchFieldsByIdFunction={fetchFieldsByIdAction}
            fieldSummary={superadmin.get('fieldSummary')}
          />
        ) : null}
        {superadmin.get('currPage') === 1 ? (
          <FilesetFormContainer
            isNewFileset
            recordLevelTypes={recordLevelTypes}
            datasetId={datasetId}
            preExistingValues={superadmin.get('filesetValues')}
            pageChangeFunction={pageChangeAction}
          />
        ) : null}
        {superadmin.get('currPage') === 2 ? (
          <FilesetFormContainer
            isNewFileset={false}
            datasetId={datasetId}
            recordLevelTypes={recordLevelTypes}
            preExistingValues={superadmin.get('filesetValues')}
            pageChangeFunction={pageChangeAction}
          />
        ) : null}
        {superadmin.get('currPage') === 3 ? (
          <UploadLayoutFormContainer
            datasetId={datasetId}
            preExistingValues={superadmin.get('filesetValues')}
            pageChangeFunction={pageChangeAction}
          />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { superadmin, dialog } = state;
  const { params } = ownProps;
  const datasetId = parseInt(params.datasetId, 10);
  const datasetName = superadmin.get('datasetNameForFileset');
  const recordLevelTypes = superadmin.get('recordLevelTypes');
  return { superadmin, dialog, datasetId, datasetName, recordLevelTypes };
}

export default connect(mapStateToProps, {
  retrieveRecordLevelTypesAction: retrieveRecordLevelTypes,
  listFilesetsAction: listFilesets,
  pageChangeAction: changePage,
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
  deleteFilesetAction: deleteFileset,
  fetchFieldsByIdAction: fetchFieldsById,
})(FilesetPageContainer);
